import React from 'react'

export function useContext (name, context) {
  const value = React.useContext(context)
  if (value === undefined) {
    throw new Error(`use${name} must be used within a ${name}Provider`)
  }
  return value
}
